module.exports = __webpack_public_path__ + "static/media/logout.5bfb706e.png";